/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { compareDependencies } from './dependenciesCompare.generated';
import { divideDependencies } from './dependenciesDivide.generated';
import { partitionSelectDependencies } from './dependenciesPartitionSelect.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMedian } from '../../factoriesAny.js';
export var medianDependencies = {
  addDependencies: addDependencies,
  compareDependencies: compareDependencies,
  divideDependencies: divideDependencies,
  partitionSelectDependencies: partitionSelectDependencies,
  typedDependencies: typedDependencies,
  createMedian: createMedian
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMedian.generated.js
// module id = 510
// module chunks = 0